var _ref2, _ref3;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgBasket = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 22.615,
      height: 21.28,
      viewBox: "0 0 22.615 21.28",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2 || (_ref2 =
    /*#__PURE__*/
    React.createElement("defs", null,
    /*#__PURE__*/
    React.createElement("clipPath", {
      id: "clip-path"
    },
    /*#__PURE__*/
    React.createElement("rect", {
      id: "Rectangle_89048",
      "data-name": "Rectangle 89048",
      width: 22.615,
      height: 21.28
    })))), _ref3 || (_ref3 =
    /*#__PURE__*/
    React.createElement("g", {
      id: "Group_19506",
      "data-name": "Group 19506",
      transform: "translate(-0.002)"
    },
    /*#__PURE__*/
    React.createElement("g", {
      id: "Group_19486",
      "data-name": "Group 19486",
      transform: "translate(0.001)",
      clipPath: "url(#clip-path)"
    },
    /*#__PURE__*/
    React.createElement("path", {
      id: "Path_24492",
      "data-name": "Path 24492",
      d: "M22.22,6.752a1.794,1.794,0,0,0-.926-.578v.007H18.015L15.2.544a.983.983,0,1,0-1.759.878l2.376,4.759H6.842L9.218,1.422A.983.983,0,1,0,7.459.544L4.645,6.181H1.368A1.718,1.718,0,0,0,0,7.854a1.344,1.344,0,0,0,.027.331L2.234,19.3A2.455,2.455,0,0,0,4.661,21.28H17.947A2.455,2.455,0,0,0,20.374,19.3L22.581,8.184a1.708,1.708,0,0,0-.361-1.433m-13.7,9.213a1.027,1.027,0,1,1-2.055,0V11.676a1.027,1.027,0,1,1,2.055,0Zm3.842,0a1.027,1.027,0,1,1-2.055,0V11.676a1.027,1.027,0,1,1,2.055,0Zm3.842,0a1.027,1.027,0,1,1-2.055,0V11.676a1.027,1.027,0,1,1,2.055,0Z",
      transform: "translate(0 0)"
    })))))
  );
};

const ForwardRef =
/*#__PURE__*/
React.forwardRef((props, ref) =>
/*#__PURE__*/
React.createElement(SvgBasket, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Basket.258ef02e.svg";
export { ForwardRef as ReactComponent };